<div hsg-modal-header *ngIf="data.title">
    <h3>{{ data.title }}</h3>
    <a class="modal-close-icon cancel" [routerLink]="data.acceptLink" [hsgModalClose]="false">
      <span class="icon-cross"></span>
    </a>
  </div>
  <div hsg-modal-body>
    {{ data.content }}
  </div>
  <div hsg-modal-footer>
    <button class="primary" [routerLink]="data.acceptLink" [hsgModalClose]="true">
      {{ data.acceptText || 'OK' }}
    </button>
    <button class="cancel" [routerLink]="data.rejectLink" [hsgModalClose]="false" *ngIf="data.rejectText">
      {{ data.rejectText }}
    </button>
  </div>